import { CircularProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';
import './UploadCsv.css';
import { useAlert } from 'react-alert';
import axios from 'axios';
import { apilink } from '../../data/fdata';
import SideBar from '../../component/sidebar/SideBar';
const UploadCsv = () => {
  const alert = useAlert();
  const [loading, setLoading] = useState(false);
  const [postfile, setPostfile] = useState([]);
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  const handelFile = (e) => {
    const { files } = e.target;
    if (files.length > 0) {
      setPostfile(files[0]);
    }
  };
  const onsub = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (postfile.size > 5000000) {
      alert.error('File should be less then 5 MB');
    } else {
      if (postfile.type === 'text/csv') {
        // console.log(postfile);
        let formData = new FormData();
        formData.append('file', postfile);

        //work done
        const res = await axios.post(
          `${apilink}/api/upload/csv_file`,
          formData,
          {
            headers: {
              'content-type': 'multipart/form-data',
              // Authorization: atokon,
            },
          }
        );
        // console.log(res.data)
        if (res.data.success) {
          alert.info(res.data.msg);
        } else {
          alert.error(res.data.msg);
        }
      } else {
        alert.error('Only CSV file allow');
      }
    }
    setLoading(false);
  };
  return (
    <>
      <div className="whole__page">
        <div className="left_side_navbar">
          <SideBar />
        </div>
        <div className="main_div ">
          <div className="main_inner_div">
            <div className="blank_page">
              <div className="container">
                <div className="row">
                  <div className="col-md-8 col-12 mx-auto">
                    <div className="card p-3">
                      <h5 className="text_blue">Upload File</h5>
                      <form action="" className="pt-2" onSubmit={onsub}>
                        <div class="form-group">
                          <input
                            type="file"
                            class="form-control"
                            accept=".csv"
                            onChange={handelFile}
                            required
                          />
                        </div>
                        <div className="text-center">
                          <button
                            type="submit"
                            className={
                              loading
                                ? 'dis btn btn-primary'
                                : 'btn btn-primary'
                            }
                            disabled={loading}
                          >
                            Upload File
                          </button>
                        </div>
                        {loading && (
                          <div className="text-center p-2">
                            <CircularProgress color="success" size={35} />
                          </div>
                        )}
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UploadCsv;
